export const APP_VERSION = 1;

export const DEFAULT_POLLING_INTERVAL = 20000;

export const locationPicPlaceholderUrl =
  'https://kursifant-static.fra1.digitaloceanspaces.com/placeholder_200.png';

export const anmeldungKursifantTooltipText = `
Standard Anmeldeverfahren über kursifant
`;

export const anmeldungVorOrtTooltipText = `
Wähle Vor Ort, wenn du nicht möchtest,<br />
dass sich deine Teilnehmer über<br />
kursifant selbst anmelden können.
`;

export const meldungBeiBuchungTooltip = `Ist diese Option aktiviert,
wird beim Buchen ein Dialog mit dem hier hinterlegten Text angezeigt, 
der bestätigt werden muss oder abgebrochen werden kann.`;

export const logsVerzoegertHint = `Die angezeigten Ereignisse können<br/>
auch nach dem Aktualisieren <br/>bis zu 2 Minuten verzögert sein`;

export const registrationDisabledText = `
Diese Organisation hat automatische Registrierung durch Benutzer deaktiviert. 
Um dich dort zu registrieren, wende dich bitte an deinen dortigen Ansprechpartner.`;
